// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 *this file is for Data Transfer Objects (Value Objects) to be used across contexts
 */
export var PaymentOrigin;
(function (PaymentOrigin) {
    PaymentOrigin["UNKNOWN"] = "UNKNOWN";
    PaymentOrigin["LOCATION"] = "LOCATION";
    PaymentOrigin["PAYMENT_PORTAL"] = "PAYMENT_PORTAL";
    PaymentOrigin["TERMINAL"] = "TERMINAL";
    PaymentOrigin["LOCATION_PORTAL"] = "LOCATION_PORTAL";
    PaymentOrigin["MOBILE_TAP_TO_PAY"] = "MOBILE_TAP_TO_PAY";
    PaymentOrigin["PAYMENT_PLAN"] = "PAYMENT_PLAN";
    PaymentOrigin["ONLINE_SCHEDULING"] = "ONLINE_SCHEDULING";
})(PaymentOrigin || (PaymentOrigin = {}));
export var PaymentOrigin_index;
(function (PaymentOrigin_index) {
    PaymentOrigin_index[PaymentOrigin_index["UNKNOWN"] = 0] = "UNKNOWN";
    PaymentOrigin_index[PaymentOrigin_index["LOCATION"] = 1] = "LOCATION";
    PaymentOrigin_index[PaymentOrigin_index["PAYMENT_PORTAL"] = 2] = "PAYMENT_PORTAL";
    PaymentOrigin_index[PaymentOrigin_index["TERMINAL"] = 3] = "TERMINAL";
    PaymentOrigin_index[PaymentOrigin_index["LOCATION_PORTAL"] = 4] = "LOCATION_PORTAL";
    PaymentOrigin_index[PaymentOrigin_index["MOBILE_TAP_TO_PAY"] = 5] = "MOBILE_TAP_TO_PAY";
    PaymentOrigin_index[PaymentOrigin_index["PAYMENT_PLAN"] = 6] = "PAYMENT_PLAN";
    PaymentOrigin_index[PaymentOrigin_index["ONLINE_SCHEDULING"] = 7] = "ONLINE_SCHEDULING";
})(PaymentOrigin_index || (PaymentOrigin_index = {}));
export var PaymentPlanStatus;
(function (PaymentPlanStatus) {
    PaymentPlanStatus["PLAN_UNKNOWN_STATUS"] = "PLAN_UNKNOWN_STATUS";
    PaymentPlanStatus["PLAN_COMPLETED"] = "PLAN_COMPLETED";
    PaymentPlanStatus["PLAN_IN_PROGRESS"] = "PLAN_IN_PROGRESS";
    PaymentPlanStatus["PLAN_PAUSED"] = "PLAN_PAUSED";
    PaymentPlanStatus["PLAN_FAILED"] = "PLAN_FAILED";
    PaymentPlanStatus["PLAN_CANCELED"] = "PLAN_CANCELED";
})(PaymentPlanStatus || (PaymentPlanStatus = {}));
export var PaymentPlanStatus_index;
(function (PaymentPlanStatus_index) {
    PaymentPlanStatus_index[PaymentPlanStatus_index["PLAN_UNKNOWN_STATUS"] = 0] = "PLAN_UNKNOWN_STATUS";
    PaymentPlanStatus_index[PaymentPlanStatus_index["PLAN_COMPLETED"] = 1] = "PLAN_COMPLETED";
    PaymentPlanStatus_index[PaymentPlanStatus_index["PLAN_IN_PROGRESS"] = 2] = "PLAN_IN_PROGRESS";
    PaymentPlanStatus_index[PaymentPlanStatus_index["PLAN_PAUSED"] = 3] = "PLAN_PAUSED";
    PaymentPlanStatus_index[PaymentPlanStatus_index["PLAN_FAILED"] = 4] = "PLAN_FAILED";
    PaymentPlanStatus_index[PaymentPlanStatus_index["PLAN_CANCELED"] = 5] = "PLAN_CANCELED";
})(PaymentPlanStatus_index || (PaymentPlanStatus_index = {}));
export var PaymentPlanPaymentType;
(function (PaymentPlanPaymentType) {
    PaymentPlanPaymentType["UNKNOWN_PAYMENT_TYPE"] = "UNKNOWN_PAYMENT_TYPE";
    PaymentPlanPaymentType["SCHEDULED_PAYMENT"] = "SCHEDULED_PAYMENT";
    PaymentPlanPaymentType["BALANCE_PAYMENT"] = "BALANCE_PAYMENT";
    PaymentPlanPaymentType["NEXT_PAYMENT"] = "NEXT_PAYMENT";
    PaymentPlanPaymentType["CANCELLED_PAYMENT"] = "CANCELLED_PAYMENT";
})(PaymentPlanPaymentType || (PaymentPlanPaymentType = {}));
export var PaymentPlanPaymentType_index;
(function (PaymentPlanPaymentType_index) {
    PaymentPlanPaymentType_index[PaymentPlanPaymentType_index["UNKNOWN_PAYMENT_TYPE"] = 0] = "UNKNOWN_PAYMENT_TYPE";
    PaymentPlanPaymentType_index[PaymentPlanPaymentType_index["SCHEDULED_PAYMENT"] = 1] = "SCHEDULED_PAYMENT";
    PaymentPlanPaymentType_index[PaymentPlanPaymentType_index["BALANCE_PAYMENT"] = 2] = "BALANCE_PAYMENT";
    PaymentPlanPaymentType_index[PaymentPlanPaymentType_index["NEXT_PAYMENT"] = 3] = "NEXT_PAYMENT";
    PaymentPlanPaymentType_index[PaymentPlanPaymentType_index["CANCELLED_PAYMENT"] = 4] = "CANCELLED_PAYMENT";
})(PaymentPlanPaymentType_index || (PaymentPlanPaymentType_index = {}));
export var PaymentPlanFrequency;
(function (PaymentPlanFrequency) {
    PaymentPlanFrequency["UNKNOWN_FREQUENCY"] = "UNKNOWN_FREQUENCY";
    PaymentPlanFrequency["BI_WEEKLY"] = "BI_WEEKLY";
    PaymentPlanFrequency["WEEKLY"] = "WEEKLY";
    PaymentPlanFrequency["MONTHLY"] = "MONTHLY";
})(PaymentPlanFrequency || (PaymentPlanFrequency = {}));
export var PaymentPlanFrequency_index;
(function (PaymentPlanFrequency_index) {
    PaymentPlanFrequency_index[PaymentPlanFrequency_index["UNKNOWN_FREQUENCY"] = 0] = "UNKNOWN_FREQUENCY";
    PaymentPlanFrequency_index[PaymentPlanFrequency_index["BI_WEEKLY"] = 1] = "BI_WEEKLY";
    PaymentPlanFrequency_index[PaymentPlanFrequency_index["WEEKLY"] = 2] = "WEEKLY";
    PaymentPlanFrequency_index[PaymentPlanFrequency_index["MONTHLY"] = 3] = "MONTHLY";
})(PaymentPlanFrequency_index || (PaymentPlanFrequency_index = {}));
/**
 * NOTE: If you update this enum, you must also update the enum in
 * shared/payments/legacy/invoice.proto,
 * schemas/payments-platform/payment_request/payment_request.proto
 */
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    InvoiceStatus["UNPAID"] = "UNPAID";
    InvoiceStatus["SCHEDULED"] = "SCHEDULED";
    InvoiceStatus["CANCELED"] = "CANCELED";
})(InvoiceStatus || (InvoiceStatus = {}));
export var InvoiceStatus_index;
(function (InvoiceStatus_index) {
    InvoiceStatus_index[InvoiceStatus_index["STATUS_UNKNOWN"] = 0] = "STATUS_UNKNOWN";
    InvoiceStatus_index[InvoiceStatus_index["PAID"] = 4] = "PAID";
    InvoiceStatus_index[InvoiceStatus_index["PARTIALLY_PAID"] = 5] = "PARTIALLY_PAID";
    InvoiceStatus_index[InvoiceStatus_index["UNPAID"] = 6] = "UNPAID";
    InvoiceStatus_index[InvoiceStatus_index["SCHEDULED"] = 7] = "SCHEDULED";
    InvoiceStatus_index[InvoiceStatus_index["CANCELED"] = 8] = "CANCELED";
})(InvoiceStatus_index || (InvoiceStatus_index = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["UNKNOWN_PAYMENT_METHOD_TYPE"] = "UNKNOWN_PAYMENT_METHOD_TYPE";
    PaymentMethodType["PAYMENT_METHOD_CARD"] = "PAYMENT_METHOD_CARD";
    PaymentMethodType["PAYMENT_METHOD_CARD_PRESENT"] = "PAYMENT_METHOD_CARD_PRESENT";
    PaymentMethodType["PAYMENT_METHOD_AFFIRM"] = "PAYMENT_METHOD_AFFIRM";
    PaymentMethodType["PAYMENT_METHOD_LINK"] = "PAYMENT_METHOD_LINK";
    PaymentMethodType["PAYMENT_METHOD_ACH"] = "PAYMENT_METHOD_ACH";
})(PaymentMethodType || (PaymentMethodType = {}));
export var PaymentMethodType_index;
(function (PaymentMethodType_index) {
    PaymentMethodType_index[PaymentMethodType_index["UNKNOWN_PAYMENT_METHOD_TYPE"] = 0] = "UNKNOWN_PAYMENT_METHOD_TYPE";
    PaymentMethodType_index[PaymentMethodType_index["PAYMENT_METHOD_CARD"] = 1] = "PAYMENT_METHOD_CARD";
    PaymentMethodType_index[PaymentMethodType_index["PAYMENT_METHOD_CARD_PRESENT"] = 2] = "PAYMENT_METHOD_CARD_PRESENT";
    PaymentMethodType_index[PaymentMethodType_index["PAYMENT_METHOD_AFFIRM"] = 3] = "PAYMENT_METHOD_AFFIRM";
    PaymentMethodType_index[PaymentMethodType_index["PAYMENT_METHOD_LINK"] = 4] = "PAYMENT_METHOD_LINK";
    PaymentMethodType_index[PaymentMethodType_index["PAYMENT_METHOD_ACH"] = 5] = "PAYMENT_METHOD_ACH";
})(PaymentMethodType_index || (PaymentMethodType_index = {}));
export var SetupFutureUsage;
(function (SetupFutureUsage) {
    SetupFutureUsage["UNKNOWN_SETUP_FUTURE_USAGE"] = "UNKNOWN_SETUP_FUTURE_USAGE";
    SetupFutureUsage["OFF_SESSION"] = "OFF_SESSION";
    SetupFutureUsage["ON_SESSION"] = "ON_SESSION";
})(SetupFutureUsage || (SetupFutureUsage = {}));
export var SetupFutureUsage_index;
(function (SetupFutureUsage_index) {
    SetupFutureUsage_index[SetupFutureUsage_index["UNKNOWN_SETUP_FUTURE_USAGE"] = 0] = "UNKNOWN_SETUP_FUTURE_USAGE";
    SetupFutureUsage_index[SetupFutureUsage_index["OFF_SESSION"] = 1] = "OFF_SESSION";
    SetupFutureUsage_index[SetupFutureUsage_index["ON_SESSION"] = 2] = "ON_SESSION";
})(SetupFutureUsage_index || (SetupFutureUsage_index = {}));
export var PaymentPlanConfirmationStatus;
(function (PaymentPlanConfirmationStatus) {
    PaymentPlanConfirmationStatus["UNKNOWN_CONFIRMATION_STATUS"] = "UNKNOWN_CONFIRMATION_STATUS";
    PaymentPlanConfirmationStatus["ACCEPT"] = "ACCEPT";
    PaymentPlanConfirmationStatus["DENY"] = "DENY";
    PaymentPlanConfirmationStatus["PENDING"] = "PENDING";
    PaymentPlanConfirmationStatus["PAUSED_BY_OFFICE"] = "PAUSED_BY_OFFICE";
})(PaymentPlanConfirmationStatus || (PaymentPlanConfirmationStatus = {}));
export var PaymentPlanConfirmationStatus_index;
(function (PaymentPlanConfirmationStatus_index) {
    PaymentPlanConfirmationStatus_index[PaymentPlanConfirmationStatus_index["UNKNOWN_CONFIRMATION_STATUS"] = 0] = "UNKNOWN_CONFIRMATION_STATUS";
    PaymentPlanConfirmationStatus_index[PaymentPlanConfirmationStatus_index["ACCEPT"] = 1] = "ACCEPT";
    PaymentPlanConfirmationStatus_index[PaymentPlanConfirmationStatus_index["DENY"] = 2] = "DENY";
    PaymentPlanConfirmationStatus_index[PaymentPlanConfirmationStatus_index["PENDING"] = 3] = "PENDING";
    PaymentPlanConfirmationStatus_index[PaymentPlanConfirmationStatus_index["PAUSED_BY_OFFICE"] = 4] = "PAUSED_BY_OFFICE";
})(PaymentPlanConfirmationStatus_index || (PaymentPlanConfirmationStatus_index = {}));
export var PaymentPlanConfirmationFrom;
(function (PaymentPlanConfirmationFrom) {
    PaymentPlanConfirmationFrom["UNKNOWN_CONFIRMATION_FROM"] = "UNKNOWN_CONFIRMATION_FROM";
    PaymentPlanConfirmationFrom["OFFICE"] = "OFFICE";
    PaymentPlanConfirmationFrom["CUSTOMER"] = "CUSTOMER";
})(PaymentPlanConfirmationFrom || (PaymentPlanConfirmationFrom = {}));
export var PaymentPlanConfirmationFrom_index;
(function (PaymentPlanConfirmationFrom_index) {
    PaymentPlanConfirmationFrom_index[PaymentPlanConfirmationFrom_index["UNKNOWN_CONFIRMATION_FROM"] = 0] = "UNKNOWN_CONFIRMATION_FROM";
    PaymentPlanConfirmationFrom_index[PaymentPlanConfirmationFrom_index["OFFICE"] = 1] = "OFFICE";
    PaymentPlanConfirmationFrom_index[PaymentPlanConfirmationFrom_index["CUSTOMER"] = 2] = "CUSTOMER";
})(PaymentPlanConfirmationFrom_index || (PaymentPlanConfirmationFrom_index = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["PAYMENT_TYPE_UNKNOWN"] = "PAYMENT_TYPE_UNKNOWN";
    PaymentType["CARD"] = "CARD";
    PaymentType["CARD_PRESENT"] = "CARD_PRESENT";
    PaymentType["AFFIRM"] = "AFFIRM";
    PaymentType["LINK"] = "LINK";
    PaymentType["ACH"] = "ACH";
})(PaymentType || (PaymentType = {}));
export var PaymentType_index;
(function (PaymentType_index) {
    PaymentType_index[PaymentType_index["PAYMENT_TYPE_UNKNOWN"] = 0] = "PAYMENT_TYPE_UNKNOWN";
    PaymentType_index[PaymentType_index["CARD"] = 1] = "CARD";
    PaymentType_index[PaymentType_index["CARD_PRESENT"] = 2] = "CARD_PRESENT";
    PaymentType_index[PaymentType_index["AFFIRM"] = 3] = "AFFIRM";
    PaymentType_index[PaymentType_index["LINK"] = 4] = "LINK";
    PaymentType_index[PaymentType_index["ACH"] = 5] = "ACH";
})(PaymentType_index || (PaymentType_index = {}));
export var CardBrand;
(function (CardBrand) {
    CardBrand["CARD_BRAND_UNKNOWN"] = "CARD_BRAND_UNKNOWN";
    CardBrand["AMEX"] = "AMEX";
    CardBrand["DINERS"] = "DINERS";
    CardBrand["DISCOVER"] = "DISCOVER";
    CardBrand["JCB"] = "JCB";
    CardBrand["MASTERCARD"] = "MASTERCARD";
    CardBrand["UNIONPAY"] = "UNIONPAY";
    CardBrand["VISA"] = "VISA";
})(CardBrand || (CardBrand = {}));
export var CardBrand_index;
(function (CardBrand_index) {
    CardBrand_index[CardBrand_index["CARD_BRAND_UNKNOWN"] = 0] = "CARD_BRAND_UNKNOWN";
    CardBrand_index[CardBrand_index["AMEX"] = 1] = "AMEX";
    CardBrand_index[CardBrand_index["DINERS"] = 2] = "DINERS";
    CardBrand_index[CardBrand_index["DISCOVER"] = 3] = "DISCOVER";
    CardBrand_index[CardBrand_index["JCB"] = 4] = "JCB";
    CardBrand_index[CardBrand_index["MASTERCARD"] = 5] = "MASTERCARD";
    CardBrand_index[CardBrand_index["UNIONPAY"] = 6] = "UNIONPAY";
    CardBrand_index[CardBrand_index["VISA"] = 7] = "VISA";
})(CardBrand_index || (CardBrand_index = {}));
export var AccountType;
(function (AccountType) {
    AccountType["CHECKING"] = "CHECKING";
    AccountType["SAVINGS"] = "SAVINGS";
})(AccountType || (AccountType = {}));
export var AccountType_index;
(function (AccountType_index) {
    AccountType_index[AccountType_index["CHECKING"] = 0] = "CHECKING";
    AccountType_index[AccountType_index["SAVINGS"] = 1] = "SAVINGS";
})(AccountType_index || (AccountType_index = {}));
export var InvoiceHistoryActionType;
(function (InvoiceHistoryActionType) {
    InvoiceHistoryActionType["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
    InvoiceHistoryActionType["ACTION_CREATED"] = "ACTION_CREATED";
    InvoiceHistoryActionType["ACTION_PAYMENT_SUCCESSFUL"] = "ACTION_PAYMENT_SUCCESSFUL";
    InvoiceHistoryActionType["ACTION_PAYMENT_FAILED"] = "ACTION_PAYMENT_FAILED";
    InvoiceHistoryActionType["ACTION_REFUND"] = "ACTION_REFUND";
    InvoiceHistoryActionType["ACTION_REMINDER"] = "ACTION_REMINDER";
    InvoiceHistoryActionType["ACTION_CANCELLATION"] = "ACTION_CANCELLATION";
    InvoiceHistoryActionType["ACTION_UPDATED"] = "ACTION_UPDATED";
    InvoiceHistoryActionType["ACTION_PROCESSING"] = "ACTION_PROCESSING";
    InvoiceHistoryActionType["ACTION_PARTIAL_REFUND"] = "ACTION_PARTIAL_REFUND";
})(InvoiceHistoryActionType || (InvoiceHistoryActionType = {}));
export var InvoiceHistoryActionType_index;
(function (InvoiceHistoryActionType_index) {
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["UNKNOWN_ACTION_TYPE"] = 0] = "UNKNOWN_ACTION_TYPE";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_CREATED"] = 1] = "ACTION_CREATED";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_PAYMENT_SUCCESSFUL"] = 2] = "ACTION_PAYMENT_SUCCESSFUL";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_PAYMENT_FAILED"] = 3] = "ACTION_PAYMENT_FAILED";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_REFUND"] = 4] = "ACTION_REFUND";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_REMINDER"] = 5] = "ACTION_REMINDER";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_CANCELLATION"] = 6] = "ACTION_CANCELLATION";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_UPDATED"] = 7] = "ACTION_UPDATED";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_PROCESSING"] = 8] = "ACTION_PROCESSING";
    InvoiceHistoryActionType_index[InvoiceHistoryActionType_index["ACTION_PARTIAL_REFUND"] = 10] = "ACTION_PARTIAL_REFUND";
})(InvoiceHistoryActionType_index || (InvoiceHistoryActionType_index = {}));
export var TerminalPaymentProcessingStatus;
(function (TerminalPaymentProcessingStatus) {
    TerminalPaymentProcessingStatus["TERMINAL_PAYMENT_STATUS_UNKNOWN"] = "TERMINAL_PAYMENT_STATUS_UNKNOWN";
    TerminalPaymentProcessingStatus["TERMINAL_PAYMENT_STATUS_IN_PROGRESS"] = "TERMINAL_PAYMENT_STATUS_IN_PROGRESS";
    TerminalPaymentProcessingStatus["TERMINAL_PAYMENT_STATUS_SUCCEEDED"] = "TERMINAL_PAYMENT_STATUS_SUCCEEDED";
    TerminalPaymentProcessingStatus["TERMINAL_PAYMENT_STATUS_FAILED"] = "TERMINAL_PAYMENT_STATUS_FAILED";
    TerminalPaymentProcessingStatus["TERMINAL_PAYMENT_STATUS_CANCELED_DUE_TO_TIMEOUT"] = "TERMINAL_PAYMENT_STATUS_CANCELED_DUE_TO_TIMEOUT";
    TerminalPaymentProcessingStatus["TERMINAL_PAYMENT_STATUS_CANCELED"] = "TERMINAL_PAYMENT_STATUS_CANCELED";
    TerminalPaymentProcessingStatus["TERMINAL_PAYMENT_STATUS_MISMATCH"] = "TERMINAL_PAYMENT_STATUS_MISMATCH";
})(TerminalPaymentProcessingStatus || (TerminalPaymentProcessingStatus = {}));
export var TerminalPaymentProcessingStatus_index;
(function (TerminalPaymentProcessingStatus_index) {
    TerminalPaymentProcessingStatus_index[TerminalPaymentProcessingStatus_index["TERMINAL_PAYMENT_STATUS_UNKNOWN"] = 0] = "TERMINAL_PAYMENT_STATUS_UNKNOWN";
    TerminalPaymentProcessingStatus_index[TerminalPaymentProcessingStatus_index["TERMINAL_PAYMENT_STATUS_IN_PROGRESS"] = 1] = "TERMINAL_PAYMENT_STATUS_IN_PROGRESS";
    TerminalPaymentProcessingStatus_index[TerminalPaymentProcessingStatus_index["TERMINAL_PAYMENT_STATUS_SUCCEEDED"] = 2] = "TERMINAL_PAYMENT_STATUS_SUCCEEDED";
    TerminalPaymentProcessingStatus_index[TerminalPaymentProcessingStatus_index["TERMINAL_PAYMENT_STATUS_FAILED"] = 3] = "TERMINAL_PAYMENT_STATUS_FAILED";
    TerminalPaymentProcessingStatus_index[TerminalPaymentProcessingStatus_index["TERMINAL_PAYMENT_STATUS_CANCELED_DUE_TO_TIMEOUT"] = 4] = "TERMINAL_PAYMENT_STATUS_CANCELED_DUE_TO_TIMEOUT";
    TerminalPaymentProcessingStatus_index[TerminalPaymentProcessingStatus_index["TERMINAL_PAYMENT_STATUS_CANCELED"] = 5] = "TERMINAL_PAYMENT_STATUS_CANCELED";
    TerminalPaymentProcessingStatus_index[TerminalPaymentProcessingStatus_index["TERMINAL_PAYMENT_STATUS_MISMATCH"] = 6] = "TERMINAL_PAYMENT_STATUS_MISMATCH";
})(TerminalPaymentProcessingStatus_index || (TerminalPaymentProcessingStatus_index = {}));
export var InvoiceOrigin;
(function (InvoiceOrigin) {
    InvoiceOrigin["INVOICE_ORIGIN_UNKNOWN"] = "INVOICE_ORIGIN_UNKNOWN";
    InvoiceOrigin["INVOICE_ORIGIN_LEGACY_DESKTOP_APP"] = "INVOICE_ORIGIN_LEGACY_DESKTOP_APP";
    InvoiceOrigin["INVOICE_ORIGIN_NWX"] = "INVOICE_ORIGIN_NWX";
    InvoiceOrigin["INVOICE_ORIGIN_PMS_INTEGRATED_BALANCE"] = "INVOICE_ORIGIN_PMS_INTEGRATED_BALANCE";
})(InvoiceOrigin || (InvoiceOrigin = {}));
export var InvoiceOrigin_index;
(function (InvoiceOrigin_index) {
    InvoiceOrigin_index[InvoiceOrigin_index["INVOICE_ORIGIN_UNKNOWN"] = 0] = "INVOICE_ORIGIN_UNKNOWN";
    InvoiceOrigin_index[InvoiceOrigin_index["INVOICE_ORIGIN_LEGACY_DESKTOP_APP"] = 1] = "INVOICE_ORIGIN_LEGACY_DESKTOP_APP";
    InvoiceOrigin_index[InvoiceOrigin_index["INVOICE_ORIGIN_NWX"] = 2] = "INVOICE_ORIGIN_NWX";
    InvoiceOrigin_index[InvoiceOrigin_index["INVOICE_ORIGIN_PMS_INTEGRATED_BALANCE"] = 3] = "INVOICE_ORIGIN_PMS_INTEGRATED_BALANCE";
})(InvoiceOrigin_index || (InvoiceOrigin_index = {}));
export var FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus;
(function (FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus) {
    FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus["FCA_BALANCE_REFRESH_UNKNOWN"] = "FCA_BALANCE_REFRESH_UNKNOWN";
    FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus["FCA_BALANCE_REFRESH_FAILED"] = "FCA_BALANCE_REFRESH_FAILED";
    FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus["FCA_BALANCE_REFRESH_PENDING"] = "FCA_BALANCE_REFRESH_PENDING";
    FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus["FCA_BALANCE_REFRESH_SUCCEEDED"] = "FCA_BALANCE_REFRESH_SUCCEEDED";
})(FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus || (FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus = {}));
export var FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index;
(function (FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index) {
    FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index[FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index["FCA_BALANCE_REFRESH_UNKNOWN"] = 0] = "FCA_BALANCE_REFRESH_UNKNOWN";
    FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index[FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index["FCA_BALANCE_REFRESH_FAILED"] = 1] = "FCA_BALANCE_REFRESH_FAILED";
    FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index[FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index["FCA_BALANCE_REFRESH_PENDING"] = 2] = "FCA_BALANCE_REFRESH_PENDING";
    FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index[FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index["FCA_BALANCE_REFRESH_SUCCEEDED"] = 3] = "FCA_BALANCE_REFRESH_SUCCEEDED";
})(FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index || (FetchFinancialConnectionsAccountQuery_BalanceRefreshStatus_index = {}));
export var FetchFinancialConnectionsAccountQuery_Balance_Type;
(function (FetchFinancialConnectionsAccountQuery_Balance_Type) {
    FetchFinancialConnectionsAccountQuery_Balance_Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
    FetchFinancialConnectionsAccountQuery_Balance_Type["TYPE_CASH"] = "TYPE_CASH";
    FetchFinancialConnectionsAccountQuery_Balance_Type["TYPE_CREDIT"] = "TYPE_CREDIT";
})(FetchFinancialConnectionsAccountQuery_Balance_Type || (FetchFinancialConnectionsAccountQuery_Balance_Type = {}));
export var FetchFinancialConnectionsAccountQuery_Balance_Type_index;
(function (FetchFinancialConnectionsAccountQuery_Balance_Type_index) {
    FetchFinancialConnectionsAccountQuery_Balance_Type_index[FetchFinancialConnectionsAccountQuery_Balance_Type_index["TYPE_UNKNOWN"] = 0] = "TYPE_UNKNOWN";
    FetchFinancialConnectionsAccountQuery_Balance_Type_index[FetchFinancialConnectionsAccountQuery_Balance_Type_index["TYPE_CASH"] = 1] = "TYPE_CASH";
    FetchFinancialConnectionsAccountQuery_Balance_Type_index[FetchFinancialConnectionsAccountQuery_Balance_Type_index["TYPE_CREDIT"] = 2] = "TYPE_CREDIT";
})(FetchFinancialConnectionsAccountQuery_Balance_Type_index || (FetchFinancialConnectionsAccountQuery_Balance_Type_index = {}));
